import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthHeader } from '../components/AuthHeader';
import { ActivityIcon, DatabaseIcon, ClockIcon } from 'lucide-react';
export const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  const modules = [{
    id: 'dems',
    name: 'Dynamic Endpoint Monitoring Service',
    description: 'Monitor and manage API endpoints across your infrastructure',
    icon: <ActivityIcon size={24} data-id="element-1184" />,
    color: 'bg-blue-100 text-blue-600',
    action: () => navigate('/dems')
  }, {
    id: 'de',
    name: 'Data Enrichment',
    description: 'Enhance and transform your data with powerful enrichment tools',
    icon: <DatabaseIcon size={24} data-id="element-1185" />,
    color: 'bg-green-100 text-green-600',
    action: () => navigate('/de')
  }, {
    id: 'cron',
    name: 'CRON Job Management',
    description: 'Schedule and monitor automated tasks and jobs',
    icon: <ClockIcon size={24} data-id="element-1186" />,
    color: 'bg-purple-100 text-purple-600',
    action: () => navigate('/cron')
  }];
  return <div className="min-h-screen bg-gray-50" data-id="element-1187">
      <AuthHeader title="Tazama Connection Studio" data-id="element-1188" />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-1189">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6" data-id="element-1190">
          {modules.map(module => <div key={module.id} className="bg-white rounded-lg shadow p-6 cursor-pointer hover:shadow-md transition-shadow duration-200" onClick={module.action} data-id="element-1191">
              <div className="flex items-start" data-id="element-1192">
                <div className={`p-3 rounded-lg ${module.color}`} data-id="element-1193">
                  {module.icon}
                </div>
                <div className="ml-4" data-id="element-1194">
                  <h3 className="text-lg font-medium text-gray-900" data-id="element-1195">
                    {module.name}
                  </h3>
                  <p className="mt-1 text-sm text-gray-500" data-id="element-1196">
                    {module.description}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </main>
    </div>;
};